/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const CheckMark: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M3.62888 7.51226C3.08336 6.88879 2.13572 6.8256 1.51226 7.37112C0.888795 7.91663 0.825604 8.86427 1.37112 9.48774L4.87112 13.4879C5.45516 14.1554 6.4877 14.1731 7.09431 13.526L14.5943 5.5259C15.1609 4.92153 15.1303 3.97227 14.5259 3.40568C13.9215 2.83909 12.9723 2.86972 12.4057 3.47409L6.03835 10.266L3.62888 7.51226Z' />
		</Svg>
	);
};

export { CheckMark };
